import isNull from 'lodash/isNull';
import addDays from 'date-fns/addDays';
import compareAsc from 'date-fns/compareAsc';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import toDate from 'date-fns/toDate';
import messages from './messages.tsx';
import type { AllowedDateRange, DateRange, ValidatorMessages, FormatMessage } from './types.tsx';

export const DATE_FORMAT = 'yyyy/MM/dd';

export const getDate = (dateString?: string): Date =>
	// @ts-expect-error - TS2769 - No overload matches this call.
	isNull(dateString) ? new Date() : new Date(dateString);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { AllowedDateRange, ValidatorMessages };

export const dateRangeValidator = (
	allowedDateRange: AllowedDateRange,
	selectedDateRange: DateRange,
	formatMessage: FormatMessage,
): ValidatorMessages => {
	const { min, max } = allowedDateRange;
	const start = toDate(getDate(selectedDateRange.startDate));
	const end = toDate(getDate(selectedDateRange.endDate));
	const startDateErrorMessages: Array<string> = [];
	const endDateErrorMessages: Array<string> = [];

	if (!isValid(start)) {
		startDateErrorMessages.push(formatMessage(messages.invalidFrom));
	}

	if (!isValid(end)) {
		endDateErrorMessages.push(formatMessage(messages.invalidTo));
	}

	if (startDateErrorMessages.length || endDateErrorMessages.length) {
		return {
			startDateErrorMessages,
			endDateErrorMessages,
		};
	}

	if (compareAsc(start, max) > 0) {
		startDateErrorMessages.push(
			formatMessage(messages.futureStartDateValidationMessage, {
				date: format(max, DATE_FORMAT),
			}),
		);
	}

	if (compareAsc(min, start) > 0) {
		startDateErrorMessages.push(
			formatMessage(messages.maxFromDateExceededMessage, {
				date: format(addDays(min, 1), DATE_FORMAT),
			}),
		);
	}

	if (compareAsc(start, end) > 0) {
		startDateErrorMessages.push(formatMessage(messages.fromDateExceededMessage));
	}

	if (compareAsc(end, max) > 0) {
		endDateErrorMessages.push(
			formatMessage(messages.futureEndDateValidationMessage, {
				date: format(max, DATE_FORMAT),
			}),
		);
	}

	return {
		startDateErrorMessages,
		endDateErrorMessages,
	};
};
